import { ActionButtonVariants } from 'components/action-button';

export const SIGN_UP_BUTTON_VARIANT = ActionButtonVariants.PRIMARY;
